/**
 * internal dependencies
 */
import { COMMON_FORM_ELEMENTS, PIN_POOL_ACTIONS } from '../utils/pin-pool-types';
import PostPinPool from '../../../../../routes/post-pin-pool';
import { showToast } from '../../../../toasts';

export const removePinPool = async (askFor: number) => {

  const awsData = {
    cardGroupId: +COMMON_FORM_ELEMENTS.ceCardGroupName.dataset.cardGroupId!,
    askFor,
    action: PIN_POOL_ACTIONS.REMOVEPOOL
  };

  try {
    const { statusCode } = await PostPinPool(awsData);
    if (statusCode === 200) {
      const poolType = askFor === 1 ? 'Pin' : 'Vehicle';
      showToast('aafp_toast', `${poolType} Pool has been disabled`);
      setTimeout(() => {
        location.reload();
      }, 2000);
    }
  } catch (error) {
    console.error('Error removing pin pool', error);
  }
};